var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c(
        "section",
        { attrs: { role: "contentinfo", "aria-label": _vm.$t(_vm.title) } },
        [
          _c("h3", { staticClass: "card-title" }, [
            _vm._v(_vm._s(_vm.$t(_vm.title)))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c("text-input-row", {
                attrs: {
                  title: "Organisation.Contacts.FirstName",
                  id: _vm.title + "_firstname",
                  required: _vm.required,
                  maxLength: 50,
                  rules: _vm.nameRules,
                  isReadOnly: _vm.isReadOnly
                },
                model: {
                  value: _vm.item.firstName,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "firstName", $$v)
                  },
                  expression: "item.firstName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c("text-input-row", {
                attrs: {
                  title: "Organisation.Contacts.LastName",
                  id: _vm.title + "_lastname",
                  required: _vm.required,
                  maxLength: 50,
                  rules: _vm.nameRules,
                  isReadOnly: _vm.isReadOnly
                },
                model: {
                  value: _vm.item.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "lastName", $$v)
                  },
                  expression: "item.lastName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c("text-input-row", {
                attrs: {
                  title: "Organisation.Phone",
                  id: _vm.title + "_phone",
                  required: _vm.required,
                  maxLength: 16,
                  rules: _vm.phoneRules,
                  isReadOnly: _vm.isReadOnly
                },
                model: {
                  value: _vm.item.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "phone", $$v)
                  },
                  expression: "item.phone"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("text-input-row", {
            attrs: {
              title: "Organisation.Email",
              id: _vm.title + "_email",
              required: _vm.required,
              maxLength: _vm.emailMaxLength,
              rules: _vm.emailRules,
              isReadOnly: _vm.isReadOnly
            },
            model: {
              value: _vm.item.email,
              callback: function($$v) {
                _vm.$set(_vm.item, "email", $$v)
              },
              expression: "item.email"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }